export default __webpack_public_path__ + "static/media/GiftsDesign.52e08c55.svg";